export const LOG_ACTION = "log-action"


// WEBPACK FOOTER //
// ./src/state/actionlog/actionLogActionTypes.ts